module.exports = __webpack_public_path__ + "static/media/Add.907537fd.svg";